import React from "react";

import Heading from "@common/components/Heading/Heading";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";

interface ResolutionRateCardProps extends ReleaseMetricCardBaseProps {
  rate: number;
  newPoints: number;
  closedPoints: number;
}

const ResolutionRateCard = ({
  style,
  rate,
  newPoints,
  closedPoints,
  score,
  highlight,
  error,
  onMoreClick,
}: ResolutionRateCardProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={"Resolution rate"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex>
        <Heading
          heading2
          style={{ marginRight: "1.8rem" }}
          marginBottom={0}
        >{`${rate.toFixed(0)}%`}</Heading>
        <Heading
          heading3
          style={{ color: vars.colors.grey60 }}
          marginBottom={0}
        >{`${closedPoints.toString()} closed pts ÷ ${newPoints.toString()} new pts`}</Heading>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { ResolutionRateCard };
